import { Injectable } from '@angular/core';

import { ConfigParserService } from '../../shared/services/config-parser.service';

export interface FirstRunCalloutsConfig {
    hideInTestMode: boolean;
    tuiFlowInTestMode: string;
    version: number;
    findMoreAppsCommercialSvg: ThemedImage;
    findMoreAppsConsumerSvg: ThemedImage;
    findMoreAppsEduSvg: ThemedImage;
    manageContentSvg: ThemedImage;
    createSvg: ThemedImage;
    uploadContentSvg: ThemedImage;
    allSetSvg: ThemedImage;
    upgradeSvg: ThemedImage;
    welcomeBackSvg: ThemedImage;
    adminCenterSvg: ThemedImage;
    officeMobileAppSvg: ThemedImage;
    installButtonCalloutEnabled: boolean;
}

interface ThemedImage {
    light: string;
    dark: string;
}

@Injectable({
    providedIn: 'root'
})
export class FirstRunCalloutsConfigService {
    public readonly config: FirstRunCalloutsConfig;

    constructor(configParserService: ConfigParserService) {
        this.config = configParserService.parse<FirstRunCalloutsConfig>('firstRunCalloutsConfig') || {
            hideInTestMode: true,
            tuiFlowInTestMode: '0',
            version: 0,
            findMoreAppsCommercialSvg: {
                light: '',
                dark: ''
            },
            findMoreAppsConsumerSvg: {
                light: '',
                dark: ''
            },
            findMoreAppsEduSvg: {
                light: '',
                dark: ''
            },
            manageContentSvg: {
                light: '',
                dark: ''
            },
            createSvg: {
                light: '',
                dark: ''
            },
            uploadContentSvg: {
                light: '',
                dark: ''
            },
            allSetSvg: {
                light: '',
                dark: ''
            },
            upgradeSvg: {
                light: '',
                dark: ''
            },
            welcomeBackSvg: {
                light: '',
                dark: ''
            },
            adminCenterSvg: {
                light: '',
                dark: ''
            },
            officeMobileAppSvg: {
                light: '',
                dark: ''
            },
            installButtonCalloutEnabled: true
        };
    }
}
